import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Users, Calendar, Phone, TrendingUp, Shield, ArrowRight, Star, Clock } from 'lucide-react';
import { servicesData } from '../data/mockData';

const MentorshipPage = () => {
  const mentorshipService = servicesData.find(s => s.title === "90-Day Mentorship Program");
  const consultationLink = "https://calendly.com/thecollinsacademynew/30min";

  return (
    <div className="dark-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">PERSONAL GUIDANCE</div>
          <h1 className="display-huge tradelines-title">
            <span className="text-gradient">90-Day Mentorship</span> Program
          </h1>
          <p className="body-large tradelines-subtitle" style={{ maxWidth: '800px', margin: '0 auto 30px' }}>
            Intensive 3-month one-on-one mentorship where you'll master credit optimization, business structure, banking relationships, and funding strategies. <strong style={{ color: 'var(--accent-gold)' }}>Credit Repair, Student Loan Removal, and an AI Business Website are all included at no extra cost.</strong>
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <Users size={24} />
              <span>1-on-1 Mentorship</span>
            </div>
            <div className="tradeline-feature-item">
              <Calendar size={24} />
              <span>12 Weekly Calls</span>
            </div>
            <div className="tradeline-feature-item">
              <Clock size={24} />
              <span>90-Day Transformation</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Service Card */}
      {mentorshipService && (
        <section className="wealth-included-section" style={{ paddingTop: '40px' }}>
          <div className="service-detail-card" style={{ maxWidth: '900px', margin: '0 auto', background: 'var(--gradient-card)', border: '1px solid var(--border-subtle)', borderRadius: '16px', padding: '40px' }}>
            <h2 className="display-small" style={{ marginBottom: '20px', color: 'var(--brand-primary)' }}>
              {mentorshipService.title}
            </h2>
            <p className="body-medium" style={{ marginBottom: '30px', color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              {mentorshipService.description}
            </p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '30px' }}>
              {mentorshipService.features.map((feature, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                  <span style={{ color: 'var(--text-primary)' }}>{feature}</span>
                </div>
              ))}
            </div>
            
            <a 
              href="https://www.fanbasis.com/agency-checkout/Formalizeai/jA1By"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mentorship-buy-btn-top"
              className="btn-primary"
              style={{ fontSize: '18px', padding: '18px 40px', display: 'inline-flex', alignItems: 'center', gap: '10px' }}
            >
              Buy Now <ArrowRight size={20} />
            </a>
          </div>
        </section>
      )}

      {/* Included Bonuses Banner */}
      <section style={{ padding: '40px 7.6923%' }} data-testid="mentorship-bonus-banner">
        <div
          style={{
            maxWidth: '1100px',
            margin: '0 auto',
            background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(138, 93, 255, 0.12))',
            border: '1.5px solid var(--accent-gold)',
            borderRadius: '18px',
            padding: '36px 32px',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              display: 'inline-block',
              background: 'var(--accent-gold)',
              color: '#1a0a2e',
              padding: '6px 14px',
              borderRadius: '999px',
              fontSize: '12px',
              fontWeight: '800',
              letterSpacing: '1px',
              marginBottom: '16px'
            }}
          >
            EVERYTHING INCLUDED — NO UPSELLS
          </div>
          <h2 style={{ color: 'white', fontSize: '28px', fontWeight: '800', marginBottom: '10px', lineHeight: '1.3' }}>
            Your 90 Days Comes Loaded — 3 Premium Services Built In
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '16px', lineHeight: '1.7', marginBottom: '26px', maxWidth: '780px' }}>
            We don't gate the work behind add-ons. The full transformation toolkit is bundled into your
            mentorship at zero extra cost — so you can rebuild, recover, and launch in parallel.
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '18px'
            }}
          >
            <div
              style={{
                background: 'rgba(12, 4, 24, 0.55)',
                border: '1px solid rgba(212, 175, 55, 0.4)',
                borderRadius: '12px',
                padding: '20px'
              }}
              data-testid="bonus-credit-repair"
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <CheckCircle2 size={20} style={{ color: 'var(--accent-gold)', flexShrink: 0 }} />
                <h3 style={{ color: 'white', fontSize: '16px', fontWeight: '700', margin: 0 }}>
                  Credit Repair
                </h3>
              </div>
              <p style={{ color: 'var(--text-secondary)', fontSize: '13px', lineHeight: '1.6', margin: 0 }}>
                Full dispute campaigns across all three bureaus to wipe inaccurate negatives and rebuild your score.
              </p>
            </div>

            <div
              style={{
                background: 'rgba(12, 4, 24, 0.55)',
                border: '1px solid rgba(212, 175, 55, 0.4)',
                borderRadius: '12px',
                padding: '20px'
              }}
              data-testid="bonus-student-loan-removal"
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <CheckCircle2 size={20} style={{ color: 'var(--accent-gold)', flexShrink: 0 }} />
                <h3 style={{ color: 'white', fontSize: '16px', fontWeight: '700', margin: 0 }}>
                  Student Loan Removal
                </h3>
              </div>
              <p style={{ color: 'var(--text-secondary)', fontSize: '13px', lineHeight: '1.6', margin: 0 }}>
                Strategic removal of qualifying student loan tradelines from your reports — instantly lifting your debt-to-income profile.
              </p>
            </div>

            <div
              style={{
                background: 'rgba(12, 4, 24, 0.55)',
                border: '1px solid rgba(212, 175, 55, 0.4)',
                borderRadius: '12px',
                padding: '20px'
              }}
              data-testid="bonus-ai-business-website"
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <CheckCircle2 size={20} style={{ color: 'var(--accent-gold)', flexShrink: 0 }} />
                <h3 style={{ color: 'white', fontSize: '16px', fontWeight: '700', margin: 0 }}>
                  AI Business Website
                </h3>
              </div>
              <p style={{ color: 'var(--text-secondary)', fontSize: '13px', lineHeight: '1.6', margin: 0 }}>
                A fully built, AI-powered business website to make your venture lender-ready and generate leads on autopilot.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="wealth-included-section">
        <div className="section-header">
          <h2 className="display-medium section-title">What's Included In Your Mentorship</h2>
          <p className="body-medium section-description">
            Comprehensive support to guide you through every step of your financial journey
          </p>
        </div>
        
        <div className="wealth-included-grid">
          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <Calendar size={32} />
            </div>
            <h3 className="wealth-included-title">12 Weekly Strategy Calls</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Dedicated one-on-one sessions</li>
              <li><CheckCircle2 size={16} /> Review progress and milestones</li>
              <li><CheckCircle2 size={16} /> Adjust strategies as needed</li>
              <li><CheckCircle2 size={16} /> Answer all your questions</li>
            </ul>
          </div>

          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <Phone size={32} />
            </div>
            <h3 className="wealth-included-title">Direct Mentor Access</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Phone and email support</li>
              <li><CheckCircle2 size={16} /> Quick response times</li>
              <li><CheckCircle2 size={16} /> Real-time guidance when needed</li>
              <li><CheckCircle2 size={16} /> No waiting for scheduled calls</li>
            </ul>
          </div>

          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <TrendingUp size={32} />
            </div>
            <h3 className="wealth-included-title">Credit & Business Mastery</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Credit optimization strategies</li>
              <li><CheckCircle2 size={16} /> Business credit curriculum</li>
              <li><CheckCircle2 size={16} /> Bank relationship development</li>
              <li><CheckCircle2 size={16} /> Funding application prep</li>
            </ul>
          </div>

          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <Shield size={32} />
            </div>
            <h3 className="wealth-included-title">90-Day Transformation</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Step-by-step action plans</li>
              <li><CheckCircle2 size={16} /> Credit monitoring setup</li>
              <li><CheckCircle2 size={16} /> Knowledge to pursue funding</li>
              <li><CheckCircle2 size={16} /> Confidence to take action</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Who It's For Section */}
      <section className="wealth-for-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Who This Mentorship Is For</h2>
        </div>
        
        <div className="wealth-for-grid">
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Entrepreneurs building business credit</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Individuals repairing personal credit</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Business owners seeking funding</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Anyone wanting financial transformation</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Those who value expert guidance</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>People ready to take action</span>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Ready To Transform Your Financial Future?</h2>
          <p className="body-large" style={{ marginBottom: '30px' }}>
            Join the 90-Day Mentorship Program and get the personalized guidance you need to succeed.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {mentorshipService && (
              <a 
                href="https://www.fanbasis.com/agency-checkout/Formalizeai/jA1By"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mentorship-buy-btn-bottom"
                className="btn-primary"
                style={{ fontSize: '18px', padding: '18px 40px' }}
              >
                Buy Now <ArrowRight size={20} />
              </a>
            )}
            <a 
              href={consultationLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ fontSize: '18px', padding: '18px 40px', background: 'transparent', border: '2px solid var(--brand-primary)' }}
            >
              Schedule Free Consultation <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentorshipPage;
